import React from "react";
import { useHistory } from "react-router-dom";
import { Aside, EditButton, useDisclosure } from "sprint-common-web";

import { AuthorizationWrapper } from "../../../../../../../../core/security/AuthorizationWrapper";
import { SprintAccessRight } from "../../../../../../../../core/security/SprintAccessRight";
import { AssetCreationWarning } from "../../../../../../common/components/AssetCreationWarning";
import { isCloudAssetDeprecated } from "../../../../../CloudAssetDetails";
import { useCloudAssetDetails } from "../../../../../common/hooks/useCloudAssetDetails";
import { resolveCloudAssetHref } from "../../../common/resolveCloudAssetHref";
import { CloudVideoAssetTechnicalForm } from "./CloudVideoAssetTechnicalForm";

export interface EditCloudVideoAssetTechnicalAsideProps {
    isLabeled?: boolean;
    aspectRatioId?: string;
    aspectTypeId?: string;
}

export const EditCloudVideoAssetTechnicalAside = (props: EditCloudVideoAssetTechnicalAsideProps): JSX.Element => {
    const { isLabeled, aspectRatioId, aspectTypeId } = props;

    const { data: assetDetails, isLoading } = useCloudAssetDetails();

    const areActionsDisabled = assetDetails && (isCloudAssetDeprecated(assetDetails) || isLoading);

    const { isOpen, onOpen, onClose } = useDisclosure();

    const history = useHistory();

    const onSubmit = (newAssetId: string) => {
        if (!assetDetails) {
            return;
        }

        const newHref = resolveCloudAssetHref(assetDetails.content.subtype, newAssetId);
        history.push(newHref);
        onClose();
    };

    if (!assetDetails) {
        return <></>;
    }

    return (
        <AuthorizationWrapper accessRights={[SprintAccessRight.AssetsReadWrite]}>
            <EditButton
                onClick={onOpen}
                isLabeled={isLabeled}
                label="Edit"
                disabled={areActionsDisabled}
                testId="edit-video-technical"
            />
            <Aside type="form" headerText="Edit technical" isOpen={isOpen} onDismiss={onClose} isLightDismiss={true}>
                <AssetCreationWarning />
                <CloudVideoAssetTechnicalForm
                    onDismiss={onClose}
                    onSubmit={onSubmit}
                    assetId={assetDetails.assetId}
                    aspectRatioId={aspectRatioId}
                    aspectTypeId={aspectTypeId}
                />
            </Aside>
        </AuthorizationWrapper>
    );
};
